const PROVIDER_BULLETS = [
  {
    id: 'wise',
    name: 'Wise',
    bg: 'bg-emerald-600',
    initials: 'W',
    bullets: [
      'Tasa de cambio más alta del mercado',
      'Comisión baja (~$0.99 por envío)',
      'Transferencia bancaria en 1-2 días',
      'Sin cargos ocultos',
    ],
    link: 'https://wise.com/invite/dic/arlindad30',
    btnColor: 'bg-emerald-600 hover:bg-emerald-500',
    badge: 'Mejor Opción',
    badgeColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    id: 'remitly',
    name: 'Remitly',
    bg: 'bg-teal-600',
    initials: 'R',
    bullets: [
      'Envío en minutos con opción Express',
      'Comisión moderada (~$1.99)',
      'Depósito bancario o retiro en efectivo',
      'Primera transferencia con tarifa especial',
    ],
    link: 'https://www.remitly.com/r/3ccs1e2j',
    btnColor: 'bg-teal-600 hover:bg-teal-500',
    badge: 'Más Rápido',
    badgeColor: 'bg-teal-100 text-teal-700',
  },
  {
    id: 'westernunion',
    name: 'Western Union',
    bg: 'bg-slate-700',
    initials: 'WU',
    bullets: [
      'Entrega instantánea en efectivo',
      'Amplia red de agentes en Venezuela',
      'No requiere cuenta bancaria',
      'Comisión más alta (~$4.99)',
    ],
    link: 'https://ssqt.co/mQNlL2e',
    btnColor: 'bg-slate-800 hover:bg-slate-700',
    badge: 'Cobro en Efectivo',
    badgeColor: 'bg-slate-100 text-slate-600',
  },
];

const COMPARISON_ROWS = [
  { category: 'Comisión', wise: '~$0.99 (Baja)', remitly: '~$1.99 (Media)', wu: '~$4.99 (Alta)' },
  { category: 'Tasa de cambio', wise: 'Mejor del mercado', remitly: 'Competitiva', wu: 'Más baja' },
  { category: 'Velocidad', wise: '1-2 días hábiles', remitly: 'Minutos (Express)', wu: 'Instantáneo' },
  { category: 'Cobro en efectivo', wise: 'No', remitly: 'Limitado', wu: 'Sí — red amplia' },
  { category: 'Cuenta bancaria requerida', wise: 'Sí', remitly: 'Sí', wu: 'No' },
  { category: 'Mejor para', wise: 'Mejor tasa y menor costo', remitly: 'Urgencia y rapidez', wu: 'Retiro en efectivo' },
];

export default function ContentSections() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Section 1: Forma más barata */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="inline-block bg-green-100 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Guía Rápida
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              ¿Cuál es la forma más barata de enviar dinero a Venezuela?
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">
              La respuesta depende de cuánto envías y qué necesita tu familiar. Aquí el resumen:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
            {[
              {
                icon: 'ri-exchange-dollar-line',
                color: 'text-emerald-600 bg-emerald-50',
                title: 'Si quieres la mejor tasa',
                desc: 'Wise tiene la tasa de cambio más alta con la comisión más baja. Ideal para envíos regulares.',
                cta: 'Enviar con Wise',
                link: 'https://wise.com/invite/dic/arlindad30',
                btnColor: 'bg-emerald-600 hover:bg-emerald-500',
              },
              {
                icon: 'ri-speed-up-line',
                color: 'text-teal-600 bg-teal-50',
                title: 'Si necesitas rapidez',
                desc: 'Remitly entrega en minutos con su opción Express. Primera transferencia con tarifa especial.',
                cta: 'Enviar con Remitly',
                link: 'https://www.remitly.com/r/3ccs1e2j',
                btnColor: 'bg-teal-600 hover:bg-teal-500',
              },
              {
                icon: 'ri-store-2-line',
                color: 'text-slate-600 bg-slate-100',
                title: 'Si necesitan efectivo',
                desc: 'Western Union permite retiro físico sin cuenta bancaria. Red amplia en Venezuela.',
                cta: 'Enviar con WU',
                link: 'https://ssqt.co/mQNlL2e',
                btnColor: 'bg-slate-800 hover:bg-slate-700',
              },
            ].map((card, i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-200 p-6 flex flex-col">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${card.color} mb-4`}>
                  <i className={`${card.icon} text-xl`} />
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-sm">{card.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed flex-1 mb-4">{card.desc}</p>
                <a
                  href={card.link}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className={`w-full flex items-center justify-center gap-2 py-3 rounded-xl text-white font-bold text-xs transition-all cursor-pointer ${card.btnColor}`}
                >
                  {card.cta} <i className="ri-arrow-right-line" />
                </a>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={() => scrollTo('comparar')}
              className="inline-flex items-center gap-2 bg-white border-2 border-green-500 text-green-700 hover:bg-green-50 font-bold text-sm px-6 py-3 rounded-xl transition-all cursor-pointer"
            >
              <i className="ri-bar-chart-2-line" />
              Ver comparación completa
            </button>
          </div>
        </div>
      </section>

      {/* Section 2: Comparación rápida (bullets) */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="inline-block bg-slate-100 text-slate-600 text-xs font-bold px-3 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Comparación Rápida
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Lo más importante de cada servicio
            </h2>
            <p className="text-gray-500 text-sm">En puntos. Sin rodeos.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {PROVIDER_BULLETS.map((p) => (
              <div key={p.id} className="bg-slate-50 rounded-2xl p-6 border border-gray-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 rounded-xl ${p.bg} flex items-center justify-center flex-shrink-0`}>
                    <span className="text-white text-xs font-bold">{p.initials}</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{p.name}</div>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${p.badgeColor}`}>{p.badge}</span>
                  </div>
                </div>
                <ul className="flex flex-col gap-2.5 mb-5">
                  {p.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
                      <i className="ri-check-line text-green-500 flex-shrink-0 mt-0.5" />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href={p.link}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className={`w-full flex items-center justify-center gap-2 py-3 rounded-xl text-white font-bold text-xs transition-all cursor-pointer ${p.btnColor}`}
                >
                  Enviar con {p.name} <i className="ri-arrow-right-line" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Wise vs Remitly vs WU */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="inline-block bg-slate-200 text-slate-700 text-xs font-bold px-3 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Comparación Detallada
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Wise vs Remitly vs Western Union
            </h2>
            <p className="text-gray-500 text-sm max-w-lg mx-auto">
              Comparación directa para que elijas sin dudas.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 overflow-x-auto mb-8">
            <table className="w-full text-sm min-w-[540px]">
              <thead>
                <tr className="bg-slate-900 text-white">
                  <th className="text-left px-5 py-4 text-xs text-slate-400 uppercase tracking-wider font-bold">Categoría</th>
                  <th className="px-5 py-4 text-center">
                    <span className="inline-block bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full">Wise</span>
                  </th>
                  <th className="px-5 py-4 text-center">
                    <span className="inline-block bg-teal-500 text-white text-xs font-bold px-3 py-1 rounded-full">Remitly</span>
                  </th>
                  <th className="px-5 py-4 text-center">
                    <span className="inline-block bg-slate-500 text-white text-xs font-bold px-3 py-1 rounded-full">Western Union</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {COMPARISON_ROWS.map((row, i) => (
                  <tr key={i} className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-slate-50/40'}`}>
                    <td className="px-5 py-3.5 text-xs font-semibold text-gray-600 uppercase tracking-wide">{row.category}</td>
                    <td className="px-5 py-3.5 text-center text-xs text-emerald-700 font-medium">{row.wise}</td>
                    <td className="px-5 py-3.5 text-center text-xs text-teal-700 font-medium">{row.remitly}</td>
                    <td className="px-5 py-3.5 text-center text-xs text-slate-600 font-medium">{row.wu}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {PROVIDER_BULLETS.map((p) => (
              <a
                key={p.id}
                href={p.link}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={`flex items-center justify-center gap-2 py-3.5 px-5 rounded-xl font-bold text-sm text-white transition-all hover:scale-105 cursor-pointer ${p.btnColor}`}
              >
                <i className="ri-send-plane-fill" />
                Enviar con {p.name}
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
